import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { G_HEADER__generations_history_item__button_lock } from './G_HEADER__generations_history_item__button_lock';
import { G_HEADER__generations_history_item__button_update_visibility } from './G_HEADER__generations_history_item__button_update_visibility';

interface PROPS {
  generation: DTO__generation;
}

export function G_HEADER__generations_history_item__buttons_bar({ generation }: PROPS) {
  return (
    <div
      className="absolute inset-0 
                  flex flex-row items-center justify-between
                  size-full 
                  bg-black/80"
    >
      <G_HEADER__generations_history_item__button_update_visibility {...{ generation }} />
      <G_HEADER__generations_history_item__button_lock {...{ generation }} />
    </div>
  );
}
